import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

export const downloadLogData = async (payload: any): Promise<any> => {
  const { tokens } = await fetchAuthSession();

  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post(
      `/dataProcessing/getLogData`,
      {
        token: idToken,
        payload,
      },
      {
        responseType: 'blob', // <-- this goes in Axios config
      }
    );
    return res;
  } else {
    throw new Error('Error fetching session');
  }
};
